import React from "react";
import { Link } from "react-router-dom";
import pictureOne from "./assets/picOne.png";

const InspectionCertificationServices = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Inspection & Certification Services</h1>
          <p className="subtitle">
            Ensuring compliance and protecting consumers through recognized certification schemes.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        <h2 className="section-title">Overview</h2>

        <p>
          Inspection and certification services are undertaken by the Quality Assurance Services Department,
          which operates product and service certification schemes to ensure that both local and imported
          goods and/or services comply with quality requirements. The aim is to protect consumers from
          unfair trade practices in quality, quantity, presentation, and labelling, based on certification
          practices recognized at the international level.
          <br /><br />
          These services are offered through the following schemes:
        </p>

        <div className="standards-grid">
          <Link to="/permit_scheme" className="standards-card">
            <h3>Permit Scheme</h3>
            <p>Ensures products meet required standards before entering the market.</p>
          </Link>
          <Link to="/designation_scheme" className="standards-card">
            <h3>Designation Scheme</h3>
            <p>Recognizes and marks products or services that comply with MBS quality standards.</p>
          </Link>
          <Link to="/Imports_Quality_Monitoring_Scheme" className="standards-card">
            <h3>Imports Quality Monitoring Scheme</h3>
            <p>Monitors imported goods to ensure conformity with national standards.</p>
          </Link>
          <Link to="/Exports_Quality_Monitoring_Scheme" className="standards-card">
            <h3>Exports Quality Certification Scheme</h3>
            <p>Certifies exported products to meet both local and international standards.</p>
          </Link>
        </div>
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
          margin: 0 auto;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .section-title {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .what-section { padding: 50px 80px; }
        .standards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 25px;
          margin-top: 25px;
        }

        .standards-card {
          background: #ff6600;
          color: white;
          border-radius: 8px;
          padding: 22px;
          font-size: 1rem;
          line-height: 1.6;
          text-align: center;
          text-decoration: none; /* removes underline */
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .standards-card h3 {
          margin-bottom: 10px;
          font-size: 1.2rem;
          font-weight: bold;
        }

        .standards-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.2);
        }

        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default InspectionCertificationServices;
